import React from "react"
import {breakpoints} from "@next/ux-fabric"
import {StyledIconButton, Icon} from "./component"
import urls from "../../config/urls"
import {useMediaQuery} from "../../hooks/useMediaQuery"

export type TabsScrollButtonProps = {
    disabled: boolean
    direction: "left" | "right"
    onClick: () => void
}

const TabsScrollButton = (props: TabsScrollButtonProps) => {
    const isMobile = useMediaQuery(`(max-width:${breakpoints.values.lg}px)`)
    if (isMobile || props.disabled) return null

    return (
        <StyledIconButton
            direction={props.direction}
            data-testid={`header-tabs-scroll-button-${props.direction}`}
            onClick={props.onClick}
            disableRipple
        >
            <Icon src={urls.arrowIconUrl} alt="" rotation={props.direction === "left" ? 90 : 270} />
        </StyledIconButton>
    )
}

export default TabsScrollButton
